export default "__VITE_ASSET__28d10611__"